import { ReactNode } from "react";
import { useToastStore, type ToastDto, type ToastType } from "@stores/notifications/toastStore";

function newToastId(): string {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }
    return `toast-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

function toToastDto(
    type: ToastType,
    title: string,
    options?: { description?: string; icon?: ReactNode; duration?: number }
): ToastDto {
    return {
        id: newToastId(),
        type,
        title,
        message: options?.description ?? "",
    };
}

/** Page toasts (success/error). Bell notifications use `useNotificationStore`. */
export const useToast = () => {
    const addNotification = useToastStore((s) => s.addNotification);

    const notify = (
        type: ToastType,
        title: string,
        options?: { description?: string; icon?: ReactNode; duration?: number }
    ) => {
        addNotification(toToastDto(type, title, options));
    };

    return {
        notify,
        success: (title: string, options?: { description?: string; duration?: number }) =>
            notify("success", title, options),
        info: (title: string, options?: { description?: string; duration?: number }) =>
            notify("info", title, options),
        warning: (title: string, options?: { description?: string; duration?: number }) =>
            notify("warning", title, options),
        error: (title: string, options?: { description?: string; duration?: number }) =>
            notify("error", title, options),
    };
};
